import sanitize from 'sanitize-html'
import Url from '@/utils/Url'

/**
 * メニュー
 * @class Menu
 */
export default class Menu {
  /**
   * @constructor
   * @param {object} param メニューオブジェクト
   */
  constructor({ menu_name, menu_icon, menu_url }) {
    /** @type {string} */
    this.name = sanitize(menu_name, { allowedTags: [] })

    /** @type {string} */
    this.icon = menu_icon

    /** @type {Url} */
    this.url = new Url(menu_url)
  }
}
